import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { EventsBrowseComponent } from './events-browse/events-browse.component';
import { EventsListComponent } from './events-list/events-list.component';
import { EventsMapComponent } from './events-map/events-map.component';
import { LeafletResolver } from '../shared/resolvers';
import { eventsMapResolver } from './events-map-resolver';

const routes: Routes = [
  {
    path: '',
    component: EventsBrowseComponent,
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'list',
      },
      {
        path: 'list',
        component: EventsListComponent,
      },
      {
        path: 'map',
        component: EventsMapComponent,
        resolve: {
          eventsGeoJSON: eventsMapResolver,
          leaflet: LeafletResolver,
        },
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class EventsBrowseRoutingModule { }
